import React from "react";

export const STATUS_LIST = [
  { key: "planeado", label: "Planeado", color: "sky", hex: "#0EA5E9" },
  { key: "en_progreso", label: "En progreso", color: "orange", hex: "#F97316" },
  { key: "revision", label: "En revisión", color: "amber", hex: "#F59E0B" },
  { key: "entregado", label: "Entregado", color: "emerald", hex: "#10B981" },
  { key: "cancelado", label: "Cancelado", color: "zinc", hex: "#6B7280" },
];

export const statusLabel = (k) => STATUS_LIST.find(s => s.key === k)?.label || k;

export const StatusPill = ({ status }) => {
  const map = {
    planeado: "bg-sky-500/10 text-sky-400 border-sky-500/20",
    en_progreso: "bg-[#F97316]/10 text-[#F97316] border-[#F97316]/20",
    revision: "bg-amber-500/10 text-amber-400 border-amber-500/20",
    entregado: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
    cancelado: "bg-zinc-500/10 text-zinc-400 border-zinc-500/20",
  };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[11px] font-medium ${map[status] || map.planeado}`}>
      {statusLabel(status)}
    </span>
  );
};

export const ProgressBar = ({ value = 0, className = "" }) => (
  <div className={`h-1.5 rounded-full bg-[#0B0D12] overflow-hidden ${className}`}>
    <div className="h-full bg-[#F97316] transition-all duration-300" style={{ width: `${Math.min(100, Math.max(0, value))}%` }}/>
  </div>
);
